import DashboardHeader from "./components/DashboardHeader";
import DashboardMenu from "./components/DashboardMenu/DashboardMenu";
import "./Dashboard.scss";
import { Outlet } from "react-router";

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard__container">
      <DashboardMenu />
      <DashboardHeader />

      <div className="dashboard">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
